import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createBody, uploadImage } from "../../../redux/actions/createcampaign";
import { Add } from "@mui/icons-material";
import {
  Button,
  Grid,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../styles/headerdata.css";
import { Col, Row } from "react-bootstrap";
import JoditEditor from "jodit-react";
import {
  getParticularforupdate,
  updateBody,
} from "../../../redux/actions/addCampaigndata";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StarRateIcon from "@mui/icons-material/StarRate";
import DeleteIcon from "@mui/icons-material/Delete";
import InputFieldOrder from "../comman/InputFieldOrder";
import { motion } from "framer-motion";

const logoSchema = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      }),
    link: yup.string().url("Invalid URL format"),
    target: yup.string().required(""),
    order: yup.string().required(""),
    alt: yup.string().required(""),
  })
);

const logoSchemaPromotionInternal = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .nullable()
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      }),
    link: yup.string().url(),
    target: yup.string(),
    order: yup.string(),
    alt: yup.string(),
  })
);

const logoSchemaForPartners = yup.array().of(
  yup.object().shape({
    file: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Unsupported file format", (value) => {
        if (!value || !value.file) {
          return true;
        }
        const file = value.file;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const supportedFormats = [
          "jpeg",
          "jpg",
          "png",
          "gif",
          "bmp",
          "svg",
          "webp",
        ];
        return supportedFormats.includes(fileExtension);
      }),
    order: yup.string(),
  })
);

const External = (props) => {
  const { handleNext, activeStep, handleBack } = props;
  const [errorMessage, setErrorMeassage] = useState("");
  const [isChecked, setIsChecked] = useState({ detail_banner_desktop: false, detail_banner_mobile: false });
  const selector = useSelector((state) => state.addCampaignReducer);
  const uiType = localStorage.getItem("uiType") || "external";
  const campaignId = localStorage.getItem("campaignId") ?? selector.campaignId;
  const campaign_type =
    localStorage.getItem("campaign_type") ??
    selector?.campaign_type?.campaign_type;
  const [disclaimerValue] = useState("");
  // console.log(isChecked, "isChecked")

  const schema = yup.object().shape({
    main_banner_desktop: logoSchema,
    campaignId: yup.string(),
    uiType: yup.string().required("UI Type is required"),
    main_heading: yup.string().required("main_heading is required"),
    main_subHeading: yup.string().required("main_subHeading is required"),
    disclaimer: yup.string().required("disclaimer is required"),
    main_banner_mobile: logoSchema,
    partners: logoSchemaPromotionInternal,
    promotional_banner_desktop: logoSchemaPromotionInternal,
    promotional_banner_mobile: logoSchemaPromotionInternal,
    partners_subHeading: yup.string(),
    partners_heading: yup.string(),
    detail_banner_desktop: logoSchemaPromotionInternal,
    detail_banner_mobile: logoSchemaPromotionInternal
  });
  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    mainDesktop: false,
    mainMobile: false,
    detailsDesktop: false,
    detailsMobile: false,
    partners: false,
    promotional_banner_mobile: false,
    promotional_banner_desktop: false,
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };

  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      main_heading: "",
      main_subHeading: "",
      uiType: "",
      campaignId: "",
      disclaimer: "",
      main_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      detail_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      detail_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      main_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      partners: [{ file: null, order: "" }],
      partners_subHeading: "",
      partners_heading: "",
      promotional_banner_desktop: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
      promotional_banner_mobile: [
        { file: null, link: "", target: "_self", order: "", alt: "" },
      ],
    },
  });

  const {
    fields: photoFields,
    append: appendPhoto,
    remove: removePhoto,
  } = useFieldArray({ control, name: "main_banner_mobile" });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "main_banner_desktop",
  });

  const {
    fields: promotionFields,
    append: promotionalAppend,
    remove: promotionalRemove,
  } = useFieldArray({ control, name: "promotional_banner_desktop" });
  const {
    fields: promotionFieldsMobile,
    append: promotionalAppendMobile,
    remove: promotionalRemoveMobile,
  } = useFieldArray({ control, name: "promotional_banner_mobile" });

  const {
    fields: partnersFields,
    append: partnersAppend,
    remove: partnersRemove,
  } = useFieldArray({ control, name: "partners" });

  const {
    fields: detailDesktopFields,
    append: detailDesktopAppend,
    remove: detailDesktopRemove,
  } = useFieldArray({ control, name: "detail_banner_desktop" });
  const {
    fields: detailMobileFields,
    append: detailMobileAppend,
    remove: detailMobileRemove,
  } = useFieldArray({ control, name: "detail_banner_mobile" });

  const handleImage = async (index, logo, e) => {

    const file = e.target.files[0];
    const isImage = file && file.type.startsWith("image/");
    // const fileSize = file.size / 1024; // Get file size in KB
    const formData = new FormData();
    formData.append("image", file);
    if (logo) {
      clearErrors(`${logo}[${index}].file`);
    }

    if (!isImage) {
      setError(`${logo}[${index}].file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    if (logo === "partners") {
      dispatch(uploadImage(formData)).then((res) => {
        setValue(`${logo}[${index}].logo`, res);
        setValue(`${logo}[${index}].file`, res);
      });
    } else {
      dispatch(uploadImage(formData)).then((res) => {
        setValue(`${logo}[${index}].image`, res);
        setValue(`${logo}[${index}].file`, res);
      });
    }
  };

  const user = localStorage.getItem("userID");

  const handleEditor = (value) => {
    if (value === "<p><br></p>") {
      setErrorMeassage("Enter Your Disclaimer");
    } else {
      setErrorMeassage("");
      setValue("disclaimer", value);
    }
  };

  const onSubmit = async (data) => {
      
    const recreatedDesktopArray = data.main_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const reacreatedDesktopArrayDetail = data.detail_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedMobileArray = data.main_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedMobileArrayDetail = data.detail_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedPromotion = data.promotional_banner_desktop.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedPromotionMob = data.promotional_banner_mobile.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const recreatedPartners = data.partners.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });

    const {
      promotional_banner_desktop,
      promotional_banner_mobile,
      campaignId,
      partners_heading,
      partners_subHeading,
      ...newDatas
    } = data;

    // Create the initial recreatedData object without promotional banners
    let recreatedData = {
      ...newDatas,
      main_banner_desktop: recreatedDesktopArray,
      main_banner_mobile: recreatedMobileArray,
      detail_banner_desktop: reacreatedDesktopArrayDetail,
      detail_banner_mobile: recreatedMobileArrayDetail,
      created_by: user,
      ...(partners_heading && {
        partners_heading: partners_heading,
      }),
      ...(partners_subHeading && {
        partners_subHeading: partners_subHeading,
      }),
      campaign_name: localStorage.getItem("campaign_name"),
      campaignId: data?.campaignId || localStorage.getItem("updateID"),
      partners: recreatedPartners,
    };
  
    // Conditionally add promotional banners if they have data
    if (recreatedPromotion?.[0]?.image) {
      recreatedData.promotional_banner_desktop = recreatedPromotion;
    } else {
      recreatedData.promotional_banner_desktop = null;
    }

    if (recreatedPromotionMob?.[0]?.image) {
      recreatedData.promotional_banner_mobile = recreatedPromotionMob;
    } else {
      recreatedData.promotional_banner_mobile = null;
    }
    if (!recreatedData?.partners?.[0]?.order) {
      recreatedData.partners = null;
    }

    const result = await dispatch(createBody(recreatedData));
    if (result?.success === true) {
      localStorage.removeItem("backClicked");
      handleNext();
    }
  };

  useEffect(() => {
    if (uiType !== null && uiType !== undefined) {
      setValue("uiType", uiType);
    }
    if (campaignId !== null && campaignId !== undefined) {
      setValue("campaignId", campaignId);
    }
  }, [uiType, campaignId]);

  const handleUrlChange = (index, logo, e) => {
    const urlValue = e.target.value.trim();
    if (
      logo === "main_banner_desktop" ||
      logo === "main_banner_mobile" ||
      logo === "promotional_banner_mobile" ||
      logo === "promotional_banner_desktop"
    ) {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].image`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    } else if (logo === "partners") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].logo`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    }
  };


  const handleCheckboxChange = (event, field) => {
    if (field === "detail_banner_desktop" || field === "detail_banner_mobile") {
      if (event.target.checked) {
        setValue(`${field}`, field === "detail_banner_desktop" ? [...watch('main_banner_desktop')] : [...watch('main_banner_mobile')]);
        setIsChecked({ ...isChecked, [field]: event.target.checked });
      } else {
        setValue(`${field}`, [{ file: null, link: "", target: "_self", order: "", alt: "" }]);
        setIsChecked({ ...isChecked, [field]: event.target.checked });
      }
    }
  };

  console.log(errors, "errors")



  return (
    <div>
      <div className="">
        <form onSubmit={handleSubmit(onSubmit)}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
            style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
          >
            Body Section
          </motion.div>
          <div className="container">
            <Row>
              <Col lg={6}>
                <div className="">
                  <div
                    className={`toggle_btn fw-bold text-center buttons rounded-2 ${errors.main_banner_desktop && "error"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleColumn("mainDesktop")}
                  >
                    Main Banner Desktop{" "}
                    <StarRateIcon
                      className={`${errors.main_banner_desktop && "text-danger"}`}
                    />{" "}
                    {columnVisibility.mainDesktop ? (
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    ) : (
                      <span>
                        <ExpandLessIcon />
                      </span>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: columnVisibility.mainDesktop ? "block" : "none",
                  }}
                >
                  <InputFieldOrder
                    fieldName={`main_banner_desktop`}
                    appendfunc={append}
                    remove={remove}
                    fieldsArray={fields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
              <Col lg={6}>
                <div className="d-flex justify-content-evenly">
                  <div
                    className={`toggle_btn fw-bold text-center buttons rounded-2 ${errors.detail_banner_desktop && "error"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleColumn("detailsDesktop")}
                  >
                    Detail Banner Desktop
                    <StarRateIcon
                      className={`${errors.detail_banner_desktop && "text-danger"}`}
                    />{" "}
                    {columnVisibility.detailsDesktop ? (
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    ) : (
                      <span>
                        <ExpandLessIcon />
                      </span>
                    )}
                  </div>

                  <>
                    <Tooltip title="Copy Main Banner Desktop to Details Banner Desktop">
                      <div className="checkbox-container mt-2">
                        <input type="checkbox" checked={isChecked?.desktop} onChange={(e) => handleCheckboxChange(e, "detail_banner_desktop")} id="detailDesktop" />
                        <label htmlFor="detailDesktop" className="custom-checkbox-label">
                          <span className="slider"></span>
                        </label>
                      </div>
                    </Tooltip>
                  </>
                </div>
                <div
                  style={{
                    display: columnVisibility.detailsDesktop ? "block" : "none",
                  }}
                >
                  <InputFieldOrder
                    fieldName={`detail_banner_desktop`}
                    appendfunc={detailDesktopAppend}
                    remove={detailDesktopRemove}
                    fieldsArray={detailDesktopFields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
              <Col lg={6}>
                <div
                  className={`toggle_btn fw-bold text-center buttons rounded-2 ${errors.main_banner_mobile && "error"
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleColumn("mainMobile")}
                >
                  Main Banner Mobile{" "}
                  <StarRateIcon
                    className={`${errors.main_banner_mobile && "text-danger"}`}
                  />{" "}
                  {columnVisibility.mainMobile ? (
                    <span>
                      <ExpandMoreIcon />
                    </span>
                  ) : (
                    <span>
                      <ExpandLessIcon />
                    </span>
                  )}
                </div>
                <div
                  style={{
                    display: columnVisibility.mainMobile ? "block" : "none",
                  }}
                >
                  <InputFieldOrder
                    fieldName={`main_banner_mobile`}
                    appendfunc={appendPhoto}
                    remove={removePhoto}
                    fieldsArray={photoFields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
              <Col lg={6}>
                <div className="d-flex justify-content-evenly">
                  <div
                    className={`toggle_btn fw-bold text-center buttons rounded-2 ${errors.detail_banner_mobile && "error"
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleColumn("detailsMobile")}
                  >
                    Details Banner Mobile
                    <StarRateIcon
                      className={`${errors.detail_banner_mobile && "text-danger"}`}
                    />{" "}
                    {columnVisibility.detailsMobile ? (
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    ) : (
                      <span>
                        <ExpandLessIcon />
                      </span>
                    )}
                  </div>
                   <div>
                    <Tooltip title="Copy Main Banner Mobile to Details Banner Mobile">
                      <div className="checkbox-container mt-2">
                        <input type="checkbox" checked={isChecked?.mobile} onChange={(e) => handleCheckboxChange(e, "detail_banner_mobile")} id="detailMobile" />
                        <label htmlFor="detailMobile" className="custom-checkbox-label">
                          <span className="slider"></span>
                        </label>
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div
                  style={{
                    display: columnVisibility.detailsMobile ? "block" : "none",
                  }}
                >
                  <InputFieldOrder
                    fieldName={`detail_banner_mobile`}
                    appendfunc={detailMobileAppend}
                    remove={detailMobileRemove}
                    fieldsArray={detailMobileFields}
                    watch={watch}
                    register={register}
                    handleImageFunc={handleImage}
                    clearErrorsfunc={clearErrors}
                    handleUrlChangefunc={handleUrlChange}
                    control={control}
                    errors={errors}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
            </Row>
            {campaign_type === "External" && (
              <Row>
                <Col lg={6}>
                  <div
                    className="toggle_btn fw-bold text-center buttons rounded-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleColumn("promotional_banner_desktop")}
                  >
                    Promotional Banner Desktop{" "}
                    {columnVisibility.promotional_banner_desktop ? (
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    ) : (
                      <span>
                        <ExpandLessIcon />
                      </span>
                    )}
                  </div>
                  <div
                    style={{
                      display: columnVisibility.promotional_banner_desktop
                        ? "block"
                        : "none",
                    }}
                  >
                    <InputFieldOrder
                      fieldName={`promotional_banner_desktop`}
                      appendfunc={promotionalAppend}
                      remove={promotionalRemove}
                      fieldsArray={promotionFields}
                      watch={watch}
                      register={register}
                      handleImageFunc={handleImage}
                      clearErrorsfunc={clearErrors}
                      handleUrlChangefunc={handleUrlChange}
                      control={control}
                      errors={errors}
                    />
                  </div>
                  <hr className="mt-3" />
                </Col>
                <Col lg={6}>
                  <div
                    className="toggle_btn fw-bold text-center buttons rounded-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleColumn("promotional_banner_mobile")}
                  >
                    Promotional Banner Mobile{" "}
                    {columnVisibility.promotional_banner_mobile ? (
                      <span>
                        <ExpandMoreIcon />
                      </span>
                    ) : (
                      <span>
                        <ExpandLessIcon />
                      </span>
                    )}
                  </div>
                  <div
                    style={{
                      display: columnVisibility.promotional_banner_mobile
                        ? "block"
                        : "none",
                    }}
                  >
                    <InputFieldOrder
                      fieldName={`promotional_banner_mobile`}
                      appendfunc={promotionalAppendMobile}
                      remove={promotionalRemoveMobile}
                      fieldsArray={promotionFieldsMobile}
                      watch={watch}
                      register={register}
                      handleImageFunc={handleImage}
                      clearErrorsfunc={clearErrors}
                      handleUrlChangefunc={handleUrlChange}
                      control={control}
                      errors={errors}
                    />
                  </div>
                  <hr className="mt-3" />
                </Col>
              </Row>
            )}

            <Row className="mt-3">
              <Col lg={6}>
                <div className="column">
                  <Controller
                    name="main_heading"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className={`form-control mb-2 ${errors.main_heading ? "error" : ""
                          }`}
                        label="Enter heading *"
                        value={field?.value || ""}
                      />
                    )}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
              <Col lg={6}>
                <div className="column">
                  <Controller
                    name="main_subHeading"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className={`form-control mb-2 ${errors.main_subHeading ? "error" : ""
                          }`}
                        label="Enter Sub Heading *"
                        value={field?.value || ""}
                      />
                    )}
                  />
                </div>
                <hr className="mt-3" />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="column">
                  <JoditEditor
                    ref={register(`disclaimer`)}
                    config={{
                      disablePrint: true,
                      disablePlugins: "insertImage",
                      toolbarAdaptive: false,
                      buttons: [
                        "source",
                        "bold",
                        "strikethrough",
                        "underline",
                        "italic",
                        "|",
                        "ul",
                        "ol",
                        "|",
                        "indent",
                        "outdent",
                        "|",
                        "font",
                        "fontsize",
                        "brush",
                        "paragraph",
                        "|",
                        "align",
                        "undo",
                        "redo",
                        "|",
                        "hr",
                        "symbol",
                        "|",
                        "fullsize",
                        "table",
                        "link",
                        "|",
                        "cut",
                        "copy",
                        "paste",
                        "selectall",
                        "|",
                        "hr",
                        "eraser",
                        "formatting",
                      ],
                    }}
                    value={disclaimerValue}
                    onChange={handleEditor}
                  />
                  {/* {console.log(errors.disclaimer, "errors.disclaimer")} */}
                  {errors?.disclaimer?.message && (
                    <div className="text-danger">
                      {errors?.disclaimer?.message}
                    </div>
                  )}
                </div>
              </Col>
              <hr className=" mt-3" />
            </Row>
            <Row>
              <Col lg={6}>
                <div
                  className={`toggle_btn fw-bold text-center buttons rounded-2 ${errors.partners && "error"
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleColumn("partners")}
                >
                  Partners{" "}
                  <StarRateIcon
                    className={`${errors.partners && "text-danger"}`}
                  />{" "}
                  {columnVisibility.partners ? (
                    <span>
                      <ExpandMoreIcon />
                    </span>
                  ) : (
                    <span>
                      <ExpandLessIcon />
                    </span>
                  )}
                </div>
                <div
                  style={{
                    display: columnVisibility?.partners ? "block" : "none",
                  }}
                >
                  {partnersFields?.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="d-flex justify-content-around mb-3 mt-2">
                        <Button
                          variant="contained"
                          component="label"
                          {...register(`partners.file`)}
                          onClick={() => clearErrors(`partners.file`)} // Clear errors for URL when file input is clicked
                        >
                          Upload File
                          <input
                            type="file"
                            {...register(`partners.file`)}
                            hidden
                            onChange={(e) => handleImage(index, "partners", e)}
                            className={`file_button mb-1 ${errors.partners && errors?.partners?.file
                              ? "error"
                              : ""
                              }`}
                          />
                        </Button>
                        {watch(`partners[${index}].logo`) && (
                          <div className="image_div">
                            <img
                              src={watch(`partners[${index}].logo`)}
                              alt=""
                              width={100}
                              height="auto"
                              className="rounded image"
                            />
                          </div>
                        )}
                      </div>
                      <div className="column">
                        <Controller
                          name={`partners[${index}].file`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Banner Url"
                              className={`form-control mb-3 ${errors.partners && errors?.partners[index]?.file
                                ? "error"
                                : ""
                                }`}
                              value={field?.value || ""}
                              onChange={(e) =>
                                handleUrlChange(index, "partners", e)
                              }
                            />
                          )}
                        />
                        <Controller
                          name={`partners[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Order"
                              select
                              className={`form-control mb-2 ${errors.partners &&
                                errors?.partners[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        {partnersFields.length > 0 && (
                          <DeleteIcon
                            onClick={() => partnersRemove(index)}
                            style={{ color: "red", cursor: "pointer" }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="form-row">
                    <Grid className="d-flex justify-content-between">
                      <Toolbar className="p-0">
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            partnersAppend({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Toolbar>
                    </Grid>
                  </div>
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="column">
                  <Controller
                    name="partners_heading"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className={`form-control mb-2 ${errors.partners_heading ? "error" : ""
                          }`}
                        label="Enter Partners Heading *"
                        value={field?.value || ""}
                      />
                    )}
                  />
                </div>
                <div className="column mt-3">
                  <Controller
                    name="partners_subHeading"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className={`form-control mb-2 ${errors.partners_subHeading ? "error" : ""
                          }`}
                        label="Enter Partners Sub-Heading *"
                        value={field?.value || ""}
                      />
                    )}
                  />
                </div>
                <hr />
              </Col>
            </Row>
            <Grid className="d-flex justify-content-between">
              <Toolbar className="p-0">
                <Button
                  className="button"
                  variant="contained"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              </Toolbar>
              <Toolbar className="p-0">
                <Button
                  className="button "
                  variant="contained"
                  disableElevation
                  endIcon={<NavigateNextIcon />}
                  type="submit"
                // onClick={handleNext}
                >
                  Save & Next
                </Button>
              </Toolbar>
            </Grid>
          </div>
        </form>
      </div>
    </div>
  );
};

export default External;
